import styled from 'styled-components';
import { DESKTOP_BREAKPOINT } from '../../utils';

export const Container = styled.section`
	display: flex;
	gap: 24px;
	padding: 32px 16px;
	margin: auto;
	max-width: 1200px;
	width: 100%;
	flex-direction: column;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		flex-direction: row;
	}
`;

export const ProfileAside = styled.aside`
	background-color: ${({ theme }) => theme.colors.neutral.white};
	display: flex;
	flex-direction: column;
	width: 100%;
	padding: 16px;
	border-radius: 12px;
	height: fit-content;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		width: 276px;
	}
`;

export const ProfilePages = styled.nav`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const Separator = styled.hr`
	height: 1px;
	padding: 0;
	margin: 16px 0;
	border: none;
	width: 100%;
	background-color: #ced4da;
`;

export const PageContent = styled.div`
	display: flex;
	flex: 1;
	flex-direction: column;
`;

export const SectionTitle = styled.div`
	${({ theme }) => theme.typography.headlines.h5};
`;

export const Form = styled.div`
	display: grid;
	gap: 20px;

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		.full-line {
			grid-column: 1/5;
		}

		.left-half {
			grid-column: 1/3;
		}

		.right-half {
			grid-column: 3/5;
		}

		& > button {
			grid-column: 1/2;
		}
	}
`;

export const TitleContainer = styled.div`
	display: grid;
	gap: 16px;
	align-items: center;
	border-bottom: 1px solid ${({ theme }) => theme.colors.neutral.grey};
	padding-bottom: 16px;

	& h1 {
		${({ theme }) => theme.typography.headlines.h5};
		grid-area: 1 / 1 / 2 / 2;
		justify-self: start;
	}

	& form {
		grid-area: 2 / 1 / 3 / 3;
	}

	& a {
		grid-area: 1 / 2 / 2 / 3;
		justify-self: end;
	}

	@media (min-width: ${DESKTOP_BREAKPOINT}px) {
		& h1 {
			grid-area: 1 / 1 / 2 / 9;
		}

		& form {
			grid-area: 1 / 5 / 2 / 11;
		}

		& a {
			grid-area: 1 / 11 / 2 / 13;
		}
	}
`;
